import { render, staticRenderFns } from "./MainNavItem.vue?vue&type=template&id=e00d56f8&scoped=true"
import script from "./MainNavItem.vue?vue&type=script&lang=ts"
export * from "./MainNavItem.vue?vue&type=script&lang=ts"
import style0 from "./MainNavItem.vue?vue&type=style&index=0&id=e00d56f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00d56f8",
  null
  
)

export default component.exports